<template>
  <div></div>
</template>

<script>
export default {
  name: 'FavoriteItemList',
  watch: {
    $route() {}
  }
};
</script>
